module.exports = __webpack_public_path__ + "img/upgrade-plan-icon.ab48a2a3.svg";